/* eslint-disable @typescript-eslint/no-explicit-any */
// AP allowing any for all these schema fragments.  If we later pull the schema apart and
// give each chunk its own type we could undo that.  It's expedient for now.
import { substanceConfig } from 'constants/substanceUse';
import { useEffect, useState } from 'react';
/**
 * checks any basic 'simple' one of our note objects to see if strings are populated and arrays have length
 * that covers textareas and checkbox lists, but not much else.
 * either improve upon this, or make your own for your use case.
 */
export var objHasData = function (obj) {
    return Object.values(obj || {}).some(function (v) { return (typeof v === 'string' && v !== '') || (Array.isArray(v) && v.length > 0); });
};
var commonSubstanceUseIsEmpty = function (suRow) {
    return Object.entries(substanceConfig)
        .filter(function (_a) {
        var v = _a[1];
        return v.isCommon;
    })
        .map(function (_a) {
        var k = _a[0];
        return k;
    })
        .includes(suRow.name) &&
        (suRow.currentUse === 'none' || suRow.currentUse === '') &&
        !suRow.comments;
};
/**
 * checks the substance use object to see if it has anything useful in it.
 */
export var substanceUseHasData = function (obj) {
    var pastUse = obj === null || obj === void 0 ? void 0 : obj.pastUse;
    var substances = obj === null || obj === void 0 ? void 0 : obj.substances;
    return ((pastUse && substances && pastUse !== '') ||
        (Array.isArray(substances) &&
            substances.some(function (s) { return objHasData(s) && !commonSubstanceUseIsEmpty(s); })));
};
/**
 * Takes a sub object out of our note and a function to check it to see if it has
 * any useful data inside, and returns a boolean based on useState and useEffect.
 */
export var useHasData = function (obj, checkFunction) {
    var _a = useState(false), hasData = _a[0], setHasData = _a[1];
    useEffect(function () {
        setHasData(checkFunction(obj));
    }, []);
    return hasData;
};
